/**
 * Arrow Up Icon Component
 *
 * Directional arrow-up icon with official toolkit sizes.
 *
 * @module @smoothie-framework/ui/icons/arrow-up-icon
 */
import { createIconNode } from '../create-icon';
const ARROW_UP_ICON = Object.freeze({
    sm: {
        viewBox: '0 0 16 16',
        paths: [
            { d: 'M8 13.5V2.5', stroke: 'currentColor', strokeWidth: '1px', strokeLinecap: 'round', strokeLinejoin: 'round' },
            { d: 'M4.5 6L8 2.5L11.5 6', stroke: 'currentColor', strokeWidth: '1px', strokeLinecap: 'round', strokeLinejoin: 'round' },
        ],
    },
    md: {
        viewBox: '0 0 24 24',
        paths: [
            { d: 'M12 17.5V6.5', stroke: 'currentColor', strokeWidth: '1px', strokeLinecap: 'round', strokeLinejoin: 'round' },
            { d: 'M8.5 10L12 6.5L15.5 10', stroke: 'currentColor', strokeWidth: '1px', strokeLinecap: 'round', strokeLinejoin: 'round' },
        ],
    },
});
export function ArrowUpIcon(props) {
    return createIconNode(ARROW_UP_ICON, props);
}
//# sourceMappingURL=arrow-up.js.map